module.exports = __webpack_public_path__ + "c1a6936a3eb16c04e53ef15461956086.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/mouse.svg
// module id = 93
// module chunks = 0